import { useEffect, useMemo, useState } from "react";
import { UtilsService } from "../../services/utils";
import { RegistersService } from "../../services/operation/registers";
import EmptyState from "../../components/empty-state/empty-state.component";
import Footer from "../../components/footer/footer.component";
import AlertPeriod from "../../components/alert-period/alert-period";
import Header from "../../components/header/header.component";
import Aside from "../../components/aside/aside.component";
import Button from "../../components/button/button.component";
import { Controller, useForm } from "react-hook-form";
import moment from "moment";
import DatepickerComponent from "../../components/datepicker/datepicker.component";
import InvalidFeedback from "../../components/invalid-feedback/invalid-feedback.component";
import SelectComponent from "../../components/select/select.component";
import { ExcelService } from "../../utils/excel";

function CustomerReport() {
  const defaultValues = {
    range: "",
    customer: "-1",
    field: "-1",
  };

  const {
    register,
    control,
    handleSubmit,
    watch,
    setValue,
    formState: { errors },
  } = useForm<typeof defaultValues>({
    mode: "onChange",
    defaultValues,
  });

  const customerFilter = watch('customer');

  const [list, setList] = useState<any[]>([]);
  const [originalList, setOriginalList] = useState<any[]>([]);

  const [customers, setCustomers] = useState<any[]>([]);
  const [fields, setFields] = useState<any[]>([]);

  const valorTotal = useMemo(
    () => list.reduce((a, b) => a + b.valor_total, 0),
    [list]
  );
  const frutaPagada = useMemo(
    () => list.reduce((a, b) => a + b.total_pagado, 0),
    [list]
  );
  const kgFruta = useMemo(
    () => list.reduce((a, b) => a + b.kg_totales, 0),
    [list]
  );

  const filter = (data: typeof defaultValues) => {
    const range = data.range;
    const customer = data.customer;
    const field = data.field;

    if (!range && customer === "-1" && field === '-1') {
      return setList(originalList);
    }

    const listFiltered = originalList
      .filter((row) => {
        return customer === "-1" || customer === row.customer._id;
      })
      .filter((row) => {
        return field === "-1" || field === row.field._id;
      })
      .filter((row) => {
        return (
          range.length !== 2 ||
          moment(row.date).isBetween(
            moment(range[0]),
            moment(range[1]),
            "days",
            "[]"
          )
        );
      });

    setList(listFiltered);
  };

  const getList = async () => {
    let data = await RegistersService.list();

    // data = data.map((row: any) => {
    //   const total = row.customers.reduce(
    //     (acc: number, c: any) => acc + c.valor_total,
    //     0
    //   );
    //   const totalPayments = row.customers.reduce(
    //     (acc: number, c: any) =>
    //       acc + c.pagos.reduce((payment: any, p: any) => payment + p.monto, 0),
    //     0
    //   );
    //   return {
    //     ...row,
    //     valorTotal: total,
    //     totalPayments: totalPayments,
    //     totalDue: total - totalPayments,
    //     status: getStatus(row).toLowerCase(),
    //   };
    // });

    let customers: any = {};
    let customersList = [];

    for (const row of data) {
      // if (!row.packing) continue;
      for (const customer of row.customers) {
        if (customers[customer.customer._id]) {
          customers[customer.customer._id].push({
            customer: customer.customer,
            field: customer.field,
            cajas: customer.cajas,
            peso_caja: customer.peso_caja,
            kg_totales: customer.kg_totales,
            valor_total: customer.valor_total,
            pagos: customer.pagos,
            folio_corrida: row.packing?.folio_corrida || '-',
            date: row.general.date,
            total_pagado: customer.pagos.reduce(
              (a: any, b: any) => a + b.monto,
              0
            ),
          });

          // customers[customer.customer._id].total_pagado.push(customer.field);

          const c = customersList.find( c => c.value === customer.customer._id);

          if(!c!.fields.find( f => f._id === customer.field._id )) {
            c!.fields.push(customer.field)
          }
          

        } else {
          customers[customer.customer._id] = [
            {
              customer: customer.customer,
              field: customer.field,
              cajas: customer.cajas,
              peso_caja: customer.peso_caja,
              kg_totales: customer.kg_totales,
              valor_total: customer.valor_total,
              pagos: customer.pagos,
              folio_corrida: row.packing?.folio_corrida || '-',
              date: row.general.date,
              total_pagado: customer.pagos.reduce(
                (a: any, b: any) => a + b.monto,
                0
              ),
            },
          ];

          customersList.push({
            value: customer.customer._id,
            text: customer.customer.name,
            fields: [customer.field]
          });
        }
      }
    }

    setList(Object.values(customers).flat());
    setOriginalList(Object.values(customers).flat());

    setCustomers([{ value: "-1", text: "Todos los productores" }, ...customersList]);
  };

  const download = () => {
    ExcelService.fromTable("kt_table_users");
  };

  useEffect(() => {
    if(customerFilter === "-1") {
      setFields([{ value: "-1", text: "Todas las huertas" }]);
    } else {
      const $fields = customers.find( c => c.value === customerFilter).fields.map( (f: any) => ({ value: f._id, text: f.name }));
      setFields([{ value: "-1", text: "Todas las huertas" }, ...$fields]);
    }

    setValue('field', '-1')
  }, [customerFilter]);

  useEffect(() => {
    getList();
  }, []);

  return (
    <>
      <div className="d-flex flex-column flex-root">
        <div className="page d-flex flex-row flex-column-fluid">
          <Aside />
          <div
            className="wrapper d-flex flex-column flex-row-fluid"
            id="kt_wrapper"
          >
            <Header />
            <div
              className="content fs-6 d-flex flex-column flex-column-fluid"
              id="kt_content"
            >
              <div className="toolbar" id="kt_toolbar">
                <div className="container-fluid d-flex flex-stack flex-wrap flex-sm-nowrap">
                  <div className="d-flex flex-column align-items-start justify-content-center flex-wrap me-2">
                    <h1 className="text-gray-900 fw-bold my-1 fs-2">
                      Reporte por Productor/Huerta
                      <small className="text-muted fs-6 fw-normal ms-1" />
                    </h1>
                    <ul className="breadcrumb fw-semibold fs-base my-1">
                      <li className="breadcrumb-item text-muted">Operación</li>
                      <li className="breadcrumb-item text-muted">Cortes</li>
                      <li className="breadcrumb-item text-gray-900">
                        Reporte por Productor/Huerta
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              <div className="container-xxl mb-5">
                <AlertPeriod />
              </div>

              <div className="post fs-6 d-flex flex-column-fluid" id="kt_post">
                <div className="container-xxl">
                  <div className="card mb-4">
                    <div className="card-body">
                      <div className="d-flex align-items-end column-gap-4 mb-6">
                        <h4 className="mb-6">
                          Filtros <i className="bi bi-funnel-fill" />
                        </h4>
                      </div>

                      <div className="d-flex align-items-end column-gap-4">
                        <div className="flex-grow-1">
                          <Controller
                            name="range"
                            control={control}
                            rules={{ required: false }}
                            render={({
                              field: { onChange, value },
                              fieldState: { error },
                            }) => {
                              let valueFormatted = "";

                              if (Array.isArray(value) && value.length === 2) {
                                const start = moment(value[0]).format(
                                  "DD-MM-YYYY"
                                );
                                const end = value[1]
                                  ? moment(value[1]).format("DD-MM-YYYY")
                                  : "";
                                valueFormatted = `Del ${start} al ${end}`;
                              }
                              return (
                                <>
                                  <DatepickerComponent
                                    label="Rango de fechas"
                                    errors={error}
                                    onChange={onChange}
                                    value={valueFormatted}
                                    mode="range"
                                    // disable={[
                                    //   {
                                    //     from: moment()
                                    //       .add(1, "days")
                                    //       .format("YYYY-MM-DD"),
                                    //     to: moment()
                                    //       .add(1, "years")
                                    //       .format("YYYY-MM-DD"),
                                    //   },
                                    // ]}
                                  />
                                  <InvalidFeedback error={error} />
                                </>
                              );
                            }}
                          />
                        </div>
                        <div className="flex-grow-1">
                          <SelectComponent
                            label="Productor"
                            data={customers}
                            {...register("customer", { required: false })}
                            errors={errors.customer}
                          />
                        </div>
                        <div className="flex-grow-1">
                          <SelectComponent
                            label="Huerta"
                            data={fields}
                            {...register("field", { required: false })}
                            errors={errors.field}
                          />
                        </div>

                        <div className="ms-auto">
                          <Button
                            className="btn btn-primary"
                            onClick={handleSubmit(filter)}
                          >
                            Filtrar
                          </Button>
                        </div>
                        <div className="nowrap">
                          <Button
                            className="btn btn-light-primary"
                            onClick={download}
                          >
                            <i className="bi bi-download"></i>
                            Descargar
                          </Button>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="mb-4 d-flex column-gap-4">
                    <div className="card flex-grow-1 text-center">
                      <div className="card-body">
                        <div className="fs-2x fw-bold">
                          $ {UtilsService.numberFormat(valorTotal)}
                        </div>
                        <div className="fs-4 fw-semibold text-gray-500">
                          Valor total
                        </div>
                      </div>
                    </div>
                    <div className="card flex-grow-1 text-center">
                      <div className="card-body">
                        <div className="fs-2x fw-bold">
                          $ {UtilsService.numberFormat(frutaPagada)}
                        </div>
                        <div className="fs-4 fw-semibold text-gray-500">
                          Fruta pagada
                        </div>
                      </div>
                    </div>
                    <div className="card flex-grow-1 text-center">
                      <div className="card-body">
                        <div className="fs-2x fw-bold">
                          {UtilsService.numberFormat(kgFruta)}
                        </div>
                        <div className="fs-4 fw-semibold text-gray-500">
                          KG. Totales
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="card">
                    <div className="card-body py-4">
                      <div
                        className="dt-container dt-bootstrap5 dt-empty-footer"
                        id="kt_table_users_wrapper"
                      >
                        <div className="table-responsive" id="">
                          <table
                            className="table align-middle table-row-dashed fs-6 gy-5 dataTable"
                            id="kt_table_users"
                          >
                            <thead>
                              <tr
                                className="text-start text-muted fw-bold fs-7 text-uppercase gs-0"
                                role="row"
                              >
                                <th
                                  aria-label="Role: Activate to sort"
                                  className="min-w-125px "
                                  colSpan={1}
                                  rowSpan={1}
                                  tabIndex={0}
                                >
                                  <span
                                    className=""
                                    
                                  >
                                    Productor
                                  </span>
                                  <span className="dt-column-order" />
                                </th>
                                <th
                                  className="min-w-125px "
                                  colSpan={1}
                                  rowSpan={1}
                                  tabIndex={0}
                                >
                                  <span
                                    className=""
                                    
                                  >
                                    Huerta
                                  </span>
                                  <span className="dt-column-order" />
                                </th>
                                <th
                                  className="min-w-125px "
                                  colSpan={1}
                                  rowSpan={1}
                                  tabIndex={0}
                                >
                                  <span
                                    className=""
                                    
                                  >
                                    Folio de corrida
                                  </span>
                                  <span className="dt-column-order" />
                                </th>
                                <th
                                  className="min-w-125px "
                                  colSpan={1}
                                  rowSpan={1}
                                  tabIndex={0}
                                >
                                  <span
                                    className=""
                                    
                                  >
                                    Fecha
                                  </span>
                                  <span className="dt-column-order" />
                                </th>
                                <th
                                  className="min-w-125px "
                                  colSpan={1}
                                  rowSpan={1}
                                  tabIndex={0}
                                >
                                  <span
                                    className=""
                                    
                                  >
                                    Kg totales
                                  </span>
                                  <span className="dt-column-order" />
                                </th>
                                <th
                                  className="min-w-125px "
                                  colSpan={1}
                                  rowSpan={1}
                                  tabIndex={0}
                                >
                                  <span
                                    className=""
                                    
                                  >
                                    Valor total
                                  </span>
                                  <span className="dt-column-order" />
                                </th>
                                <th
                                  className="min-w-125px "
                                  colSpan={1}
                                  rowSpan={1}
                                  tabIndex={0}
                                >
                                  <span
                                    className=""
                                    
                                  >
                                    Fruta pagada
                                  </span>
                                  <span className="dt-column-order" />
                                </th>
                              </tr>
                            </thead>
                            <tbody className="text-gray-600 fw-semibold">
                              {list.map((row: any, index: number) => (
                                <tr key={index}>
                                  <td>{row.customer.name}</td>
                                  <td>{row.field.name}</td>
                                  <td>{row.folio_corrida}</td>
                                  <td>
                                    {UtilsService.dateFormat(
                                      row.date,
                                      "DD/MM/YYYY"
                                    )}
                                  </td>
                                  <td>
                                    {UtilsService.numberFormat(row.kg_totales)}
                                  </td>
                                  <td>
                                    ${" "}
                                    {UtilsService.numberFormat(row.valor_total)}
                                  </td>
                                  <td>
                                    ${" "}
                                    {UtilsService.numberFormat(
                                      row.total_pagado
                                    )}
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                            <tfoot />
                          </table>

                          {list.length === 0 && <EmptyState />}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <Footer />
          </div>
        </div>
      </div>
    </>
  );
}

export default CustomerReport;
